import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const tools = [{
  title: 'Manual Fundamental de Tarot Terapéutico',
  description: 'Una base completa para comprender y aplicar el Tarot.'
}, {
  title: 'Sistema Profesional de Interpretación Terapéutica',
  description: 'Un método para conectar e interpretar las cartas.'
}, {
  title: 'Biblioteca de 200 Preguntas de Exploración Emocional',
  description: 'Preguntas para profundizar cada lectura.'
}, {
  title: 'Métodos de Tiradas Terapéuticas',
  description: 'Estructuras prácticas para diferentes consultas.'
}, {
  title: 'Fichas de Anamnesis y Evaluación Terapéutica',
  description: 'Recursos para preparar y registrar sesiones.'
}, {
  title: 'Diario de Interpretación y Evolución Personal',
  description: 'Un espacio para registrar reflexiones y avances.'
}, {
  title: 'Guía Práctica de Lectura + Cartas Rider Waite',
  description: 'Aprendé símbolos, arcanos y conexiones entre cartas.'
}, {
  title: 'Sistema de Seguimiento Terapéutico para Consultantes',
  description: 'Herramientas para registrar el proceso de cada consultante.'
}];
const titleReveal = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    amount: 0.15
  },
  transition: {
    duration: 0.55,
    ease: [0.22, 1, 0.36, 1] as const
  }
};
const copyReveal = {
  initial: {
    opacity: 0,
    y: 15
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    amount: 0.15
  },
  transition: {
    duration: 0.45,
    delay: 0.1,
    ease: [0.22, 1, 0.36, 1] as const
  }
};
export function WhatYouReceive() {
  const scrollToPurchase = () => document.getElementById('purchase')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section className="bg-[#fffdf8] py-12 sm:py-16" data-id="element-268" data-mp="1snbild1rw4m4">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-8" data-id="element-269" data-mp="1sompvmuffuhz">
        <div className="text-center" data-id="element-270" data-mp="1xmwjht0i6n1h">
          <motion.h2 {...titleReveal} className="font-magical text-4xl font-bold uppercase leading-none tracking-tight text-purple-950 sm:text-5xl" data-id="element-271" data-mp="1xnz97xm3ajft">
            ¿Qué vas a recibir?
          </motion.h2>
          <motion.p {...copyReveal} className="mx-auto mt-3 max-w-xl text-sm font-medium leading-relaxed text-purple-950/70 sm:text-base" data-id="element-272" data-mp="1ko6y17imlluy">
            8 herramientas profesionales para interpretar, preparar y organizar tus lecturas.
          </motion.p>
        </div>

        <ul className="mt-8 grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-2.5 sm:gap-4" data-id="element-273" data-mp="28iqd4m1xo78h">
          {tools.map((tool, index) => <motion.li key={tool.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.55,
          delay: index * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative flex min-h-[128px] flex-col rounded-xl border border-[#e6d3a8] bg-[#fffaf0] p-3 shadow-[0_6px_16px_-12px_rgba(76,29,149,0.25)] sm:min-h-[138px]" data-id="element-274" data-mp="23j40oetxiv0q" data-mpi={index}>
              <span className="w-fit rounded-full bg-[#b88631] px-2 py-0.5 text-[10px] font-black text-white" data-id="element-275" data-mp="35v54b24niq2k">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-3 font-magical text-[15px] font-bold leading-[1.1] text-purple-950 sm:text-lg" data-id="element-276" data-mp="2ww1oc70s6qsa">
                {tool.title}
              </h3>
              <p className="mt-1.5 text-[11px] leading-snug text-purple-950/70 sm:text-xs" data-id="element-277" data-mp="2n68dj88gqfp3">
                {tool.description}
              </p>
            </motion.li>)}
        </ul>

        <motion.div {...copyReveal} className="mx-auto mt-7 max-w-xl text-center" data-id="element-278" data-mp="2e6lj56e5ia5j">
          <p className="font-magical text-2xl font-bold leading-tight text-purple-950 sm:text-3xl" data-id="element-279" data-mp="2i6vr2oli7an1">
            No son 8 recursos sueltos. Es un <strong className="font-bold text-purple-800" data-id="element-280" data-mp="248nvol448hdz">sistema completo</strong> para <strong className="font-bold text-purple-800" data-id="element-281" data-mp="295xkpznler1a">interpretar con más seguridad</strong>.
          </p>
          <motion.button onClick={scrollToPurchase} whileTap={{
          opacity: 0.92
        }} className="cta-desktop-hover mt-5 flex w-full items-center justify-center gap-3 overflow-hidden rounded-xl bg-purple-900 px-5 py-4 text-sm font-black uppercase tracking-[0.1em] text-white shadow-[0_10px_24px_rgba(76,29,149,0.24)] transition-[background-color,box-shadow,opacity] duration-200 ease-out hover:bg-purple-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-900 sm:text-base" data-id="element-282" data-mp="3bjvdpz5jpdpn">
            <span className="cta-occasional-shine pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 skew-x-[-20deg]" aria-hidden="true" data-id="element-283" data-mp="2jsfjpk1nsope" />
            <span className="relative flex items-center gap-3" data-id="element-284" data-mp="2ew77ofirdbmg">
              Quiero mi kit completo <ArrowRight size={20} aria-hidden="true" data-id="element-285" data-mp="i1c8asjy363s" />
            </span>
          </motion.button>
        </motion.div>
      </div>
    </section>;
}